import axios from 'axios';
import { API } from 'configs/api';

export const suggestionService = {
  getSuggestion: (id) => axios.get(`${API.suggestion}/${id}`, { token: false }),
};
